export enum Role {
    Admin = "PointSAdmin",
    SystemAdmin = "SuperAdmin"
}
